var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/offers") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/offers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#B2B2B2",
    strokeWidth: 1.3,
    fill: "#FFFFFF",
    cx: 12,
    cy: 12,
    r: 7.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 6.3,
    x2: 12,
    y2: 17.3,
    id: "Path",
    stroke: "#B2B2B2",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,8.3 L10.75,8.3 C9.78350169,8.3 9,9.08350169 9,10.05 C9,11.0164983 9.78350169,11.8 10.75,11.8 L13.25,11.8 C14.2164983,11.8 15,12.5835017 15,13.55 C15,14.5164983 14.2164983,15.3 13.25,15.3 L9,15.3",
    id: "Path",
    stroke: "#B2B2B2",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffers);
export default __webpack_public_path__ + "static/media/offers.ca0fca03642797c5b0f12e2c7285da48.svg";
export { ForwardRef as ReactComponent };